import { jsx as a } from "react/jsx-runtime";
function i({
  count: e,
  max: t = 99,
  label: n,
  className: m
}) {
  return !Number.isFinite(e) || e <= 0 ? null : /* @__PURE__ */ a(
    "span",
    {
      className: m ? `nim-comment-count-badge ${m}` : "nim-comment-count-badge",
      "data-testid": "comment-count-badge",
      "aria-label": n ?? `${e} comment ${e === 1 ? "thread" : "threads"}`,
      children: e > t ? `${t}+` : e
    }
  );
}
export {
  i as C
};
//# sourceMappingURL=CommentCountBadge-BNeNtSLb.js.map
